import { FC, useRef } from "react";

import styles from "./styles.module.scss";

type Props = {
    open: boolean;
    onClose: () => void;
    children?: React.ReactNode;
    size?: "small" | "medium" | "large";
    className?: string;
    canClose?: boolean;
};

const Modal: FC<Props> = ({
    open,
    onClose,
    children,
    size = "medium",
    className,
    canClose = true,
}) => {
    const modalRef = useRef<HTMLDivElement>(null);

    const handleClickOutside = (e: React.MouseEvent<HTMLDivElement>) => {
        if (modalRef.current && e.target === modalRef.current) {
            onClose();
        }
    };

    return (
        <div
            className={`${styles.container} ${
                open ? styles["container--visible"] : ""
            }`}
            ref={modalRef}
            onClick={canClose ? handleClickOutside : undefined}
        >
            <div className={`${styles.modal} ${styles[`modal--${size}`]} ${className}`}>
                {children}
            </div>
        </div>
    );
};

export default Modal;
